"use client"

import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from "@/components/ui/sidebar"

import {
    ArrowUpCircleIcon,
    BarChartIcon,
    CameraIcon,
    ClipboardListIcon,
    MapIcon,
    LayoutDashboard,
    BanknoteArrowUp,
    ListCheck,
    BanknoteArrowDown,
    Fuel,
    Car,
    Smartphone,
    User,
    ListIcon,
    Calendar,
    Route,
    UsersIcon,
    SquarePercent,
} from "lucide-react"
import { useTranslate } from "react-admin";
import { NavLink, useLocation } from "react-router-dom";

export function TaxiDispatchCommsionPartner() {
    const {pathname} = useLocation()

    const translate = useTranslate();

    const data = {
        dispatch: {
            title: "Dispatch",
            navs: [
                {
                    name: "New Order",
                    url: "/",
                    icon: LayoutDashboard,
                },
                {
                    name: translate(`orders.name`, { smart_count: 2 }),
                    url: "/taxi-orders",
                    icon: ListIcon,
                },
            ]
        }
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.dispatch.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton className="text-[15px] font-medium" asChild>
                            <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
